import {
  getCurrentLanguage,
  uuid,
  getConfig,
  getCurrentCountry
} from "../utils";
import { hmacSHA256Hash} from "../utils/crypto";

export interface GatewayHeaders{
  timestamp:string,
  nonce:string,
  sign:string,
  appCode:string,
  bizSource:string,
  country:string,
  appLang:string,
  appLabel:string,
  appVersion:string,
  deviceType:string,
}
/**
 * 获取 gateway 请求头(通过 idToken 鉴权)
 * @returns
 */
export const getGatewayHeaders = async ():Promise<GatewayHeaders> => {
  const timestamp = Math.ceil(new Date().getTime() / 1000) + ''
  const nonce = uuid().replace(/-/g,'');
  const sign = hmacSHA256Hash(`timestamp=${timestamp}&nonce=${nonce}`,getConfig("CryptoKey") as string);
  const country = getCurrentCountry();
  const lang = getCurrentLanguage();
  const appLang = lang.startsWith('zh') ? "zh-CN" : lang;
  const headers = {
    timestamp,
    nonce,
    sign,
    appCode: "h5",
    bizSource: "MERCHANT",
    country,
    appLang,
    appLabel:'*',
    appVersion: '*',
    deviceType: 'web',
  };
  return headers;
};
